import { render } from "./PR12-081022.vue?vue&type=template&id=5306e2f8"
import script from "./PR12-081022.vue?vue&type=script&lang=js"
export * from "./PR12-081022.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__